// extracted by mini-css-extract-plugin
export var container = "_em-0";
export var infoIcon = "_em-2";
export var titleRowCol = "_em-1";